<div class="ind-app-numbers-container">
  <div class="ind-app-numbers-item-container">
    <div class="ind-app-numbers-item-input-container">
      <mat-form-field appearance="outline" class="ind-app-numbers-form-field">
        <mat-label>IND application number(s)</mat-label>
        <input matInput #indApplicationNumbersInput [(ngModel)]="indApplicationNumbers" class="ind-app-numbers ind-app-numbers-item-input"
          (keyup.enter)="updateIndApplicationNumbers($event)" (keyup.escape)="cancelUpdate()" (blur)="updateIndApplicationNumbers($event)" />
        <mat-icon matSuffix class="ind-app-numbers-trailing-icon" (mousedown)="clearIndApplicationNumbersInputField()">cancel</mat-icon>
      </mat-form-field>
    </div>
    <div class="input-error" *ngIf="hasFieldValidationError('indApplicationNumbers')">
      This is a required field.
    </div>
  </div>
</div>